import * as navigation from 'Navigation';

export default class ContainerTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'container',
    };
  }
}
